import React, { StrictMode, useState } from 'react';

import PropTypes from 'prop-types';

import useMembers from 'components/Common/Managers/Hooks/useMembers';
import { ContextProvider as TemplatesContextProvider } from 'components/Managers/Templates/Context';
import Header from './Widgets/Header';
import Statistics from './Widgets/Statistics/Index';
import TalentIndex from './Widgets/TalentIndex/Index';

export default function Index({ enterpriseId }) {
  const members = useMembers({ onlyActive: true });

  const [filteredMembers, setFilteredMembers] = useState(null);

  const onFilteredDataChange = (data) => {
    setFilteredMembers(data);
  };

  return (
    <StrictMode>
      <TemplatesContextProvider enterpriseId={enterpriseId}>
        <div className="content">
          <Header />
          <Statistics members={filteredMembers} />
        </div>

        <div className="content">
          <section>
            <TalentIndex members={members} onFilteredDataChange={onFilteredDataChange} />
          </section>
        </div>
      </TemplatesContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
};
